import React, { useState, useEffect } from 'react';
import emailValidator from 'email-validator';
import { TextField } from 'seagull';
import { useStoreActions } from "../../../contexts";
import { routes } from "../../../constants";
import UnauthorizedPageContainer from "../components/UnauthorizedPageContainer";
import { FormContainer, FormTitle, FormDescription, FormFields, VerticalFormFields, SubmitButtonField, Footer, FooterLink, ErrorMessage } from "../components/FormComponents";
import { errorMessages } from "../constants";

const SentScreen = _ref => {
  let {
    email,
    tryAgain
  } = _ref;
  return /*#__PURE__*/React.createElement(UnauthorizedPageContainer, {
    testId: "access-link-sent-msg"
  }, /*#__PURE__*/React.createElement(FormContainer, null, /*#__PURE__*/React.createElement(FormTitle, null, "Check Your Email"), /*#__PURE__*/React.createElement(FormDescription, {
    "data-testid": "request-link-sent-description"
  }, "We've sent a link to ", email, ". Check your inbox (and your spam inbox), for your newly generated access link. This link is valid for 24 hours, and can only be used once."), /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(FooterLink, {
    onClick: tryAgain
  }, "Wrong email?"))));
};

const FormScreen = _ref2 => {
  let {
    onSuccess
  } = _ref2;
  const {
    api,
    logBI
  } = useStoreActions();
  const [email, setEmail] = useState('');
  const [isEmailValid, setIsEmailValid] = useState(false);
  const [emailWasBlurred, setEmailWasBlurred] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const [resetPasswordError, setResetPasswordError] = useState(null);
  const showEmailFieldError = email !== '' && !isEmailValid && emailWasBlurred;
  return /*#__PURE__*/React.createElement(UnauthorizedPageContainer, {
    testId: "access-link-sent-msg"
  }, /*#__PURE__*/React.createElement(FormContainer, {
    onChange: () => setResetPasswordError(null),
    onSubmit: async event => {
      logBI(10700, {});
      event.preventDefault();
      setInProgress(true);

      try {
        await api.auth.issueOneTimeAccessLink(email);
        setInProgress(false);
        onSuccess(email);
      } catch (e) {
        setInProgress(false);
        setResetPasswordError(errorMessages.generalMagicLinkError);
      }
    }
  }, /*#__PURE__*/React.createElement(FormTitle, null, "Request an access link"), /*#__PURE__*/React.createElement(FormDescription, null, "Enter the email address associated with your account and we'll send you a one time access link to login your account"), /*#__PURE__*/React.createElement(FormFields, null, /*#__PURE__*/React.createElement(VerticalFormFields, null, /*#__PURE__*/React.createElement(TextField, {
    autoFocus: true,
    label: "Work email",
    type: "email",
    value: email,
    onChange: event => {
      const value = event.target.value;
      const isValid = emailValidator.validate(value);
      setEmail(value);
      setIsEmailValid(isValid);
    },
    error: showEmailFieldError,
    onBlur: () => setEmailWasBlurred(true),
    "data-testid": "email-input"
  }))), /*#__PURE__*/React.createElement(SubmitButtonField, {
    disabled: !isEmailValid,
    isLoading: inProgress,
    "data-testid": "request-link-button"
  }, "Send a link"), resetPasswordError && /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-testid": "error-msg"
  }, resetPasswordError), /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(FooterLink, {
    toInternalLink: routes.login,
    "data-testid": "back-to-login-button"
  }, "Back to login"))));
};

export function RequestLinkScreen() {
  const [email, setEmail] = useState(null);
  useEffect(() => {
    document.title = 'Anchor one time access link';
  }, []);
  return email ? /*#__PURE__*/React.createElement(SentScreen, {
    email: email,
    tryAgain: () => setEmail(null)
  }) : /*#__PURE__*/React.createElement(FormScreen, {
    onSuccess: setEmail
  });
}